<template>
  <div :class="applyActiveFolderStyle">
    <NrButton
      :aria-label="`Filter by folder ${folder.folder_name}`"
      :class="[
        'folder-row-buttons',
        'folder-row__title',
        { 'has-child-folders': !!folder.has_child_folders }
      ]"
      variant="minimal-neutral"
      @click="filterByFolder"
    >
      <NrIcon class="folder" :name="folderIconName" />
      <div class="parent-folder-name is-size-7">
        {{ truncateParentFolderName(folder.folder_name) }}
      </div>
    </NrButton>
    <span
      v-if="folder.doc_count !== undefined && folder.doc_count > 0"
      :class="[
        'folder-doc-count',
        { 'folder-doc-count--active': activeFolder }
      ]"
    >
      {{ folder.doc_count }}
    </span>
    <NrIconButton
      v-if="$can('read', 'staff_only_items')"
      @click="renameFolder"
      variant="minimal-neutral"
      size="small"
      :icon="{ name: 'pencil-alt', type: 'regular' }"
      class="edit-folder-button folder-row-buttons"
      :aria-label="`Rename folder ${folder.folder_name}`"
    />
  </div>
</template>

<script>
import NrButton from '@nextrequestco/components/src/components/NrButton'
import NrIcon from '@nextrequestco/components/src/components/NrIcon'
import NrIconButton from '@nextrequestco/components/src/components/NrIconButton'
import truncate from 'lodash/truncate'

export default {
  props: {
    folder: {
      type: Object
    },
    index: {
      type: Number
    },
    activeFolder: {
      type: Boolean
    },
    folderOpened: {
      type: Boolean
    }
  },

  components: {
    NrButton,
    NrIconButton,
    NrIcon
  },

  computed: {
    applyActiveFolderStyle() {
      return {
        'folder-button folder-button-active': this.activeFolder,
        'folder-button-no-edit-name': !this.$can(
          'read',
          'publisher_only_items'
        ),
        'folder-button': true
      }
    },

    getCaret() {
      return this.folderOpened ? 'caret-down' : 'caret-right'
    },

    folderIconName() {
      if (this.folder && this.folder.has_child_folders) {
        return this.folderOpened ? 'multi-folder-open' : 'multi-folder'
      }
      return this.activeFolder ? 'folder-open' : 'folder'
    }
  },

  methods: {
    truncateParentFolderName(folderName) {
      return truncate(folderName, { length: 28 })
    },

    filterByFolder() {
      if (this.folder && this.folder.has_child_folders) {
        this.$emit('open-folder', { index: this.index, id: this.folder.id })
      }
      this.$emit('filter-by-folder', {
        parent_folder_id: this.folder.id,
        activeId: `${this.folder.id}`,
        type: 'top folder',
        folderName: this.folder.folder_name
      })
    },
    renameFolder() {
      this.filterByFolder()
      this.$emit('rename-folder', this.folder.folder_name)
    }
  }
}
</script>
